/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsCvssScoreQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsCvssScoreQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsCvssScoreQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsCvssScoreQueryOperator>): AppSecopsCvssScoreQueryOperator {
        let obj = Object.assign(new AppSecopsCvssScoreQueryOperator(), model);
        AppSecopsCvssScoreQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsCvssScoreQueryOperator>): AppSecopsCvssScoreQueryOperator {
        if (!model) return null;
        return AppSecopsCvssScoreQueryOperator.newInstance(<AppSecopsCvssScoreQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsCvssScoreQueryOperator) {
        if (!obj) return;

        models.AppSecopsCvssScoreQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsCvssScoreQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsCvssScoreQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.cvss_score === undefined) {
            this.cvss_score = 0;
        }
    }

    /**
     * EPSS score associated with the vulnerability
     */
    cvss_score: number;

}
